import React from "react";
import UseGetDashBoardData from "../../../../../Components/Hooks/useDashboardData";
import NuDate from "../../../../../Components/Utils/NuDate";

function OrderReceived() {
  const { data, loading } = UseGetDashBoardData(`/dashboard/order-received-recently`);

  return (
    <div className="bg-white p-5 rounded-2xl border border-gray-100 shadow-[0_4px_25px_rgba(0,0,0,0.04)] transition-all duration-300">
      <div className="flex justify-between items-center pb-3 border-b border-gray-100 mb-3">
        <div className="flex items-center space-x-2">
          <div className="w-7 h-7 rounded-lg bg-emerald-50 flex items-center justify-center text-emerald-600">
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
            </svg>
          </div>
          <h3 className="text-sm font-semibold text-gray-800">Recent Orders Received</h3>
        </div>

        <span className="text-xs font-bold px-2.5 py-0.5 rounded-full bg-emerald-50 text-emerald-700 border border-emerald-200/50">
          Inward GRN Feed
        </span>
      </div>

      {loading ? (
        <div className="h-48 flex items-center justify-center animate-pulse">
          <div className="h-32 bg-gray-100 rounded-xl w-full"></div>
        </div>
      ) : (
        <div className="max-h-56 overflow-y-auto pr-1">
          <table className="w-full text-xs">
            <thead className="sticky top-0 bg-gray-50 text-gray-500 font-semibold border-b border-gray-200">
              <tr>
                <th className="py-2 px-2 text-left">Order Ref</th>
                <th className="py-2 px-2 text-center">Shipped Date</th>
                <th className="py-2 px-2 text-right">Received Date</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {data && data.length > 0 ? (
                data.map((item, index) => (
                  <tr key={index} className="hover:bg-gray-50/70 transition-colors">
                    <td className="py-2.5 px-2 font-semibold text-gray-900">{item?.order || "N/A"}</td>
                    <td className="py-2.5 px-2 text-center text-gray-500 font-medium">
                      {item?.shipped ? <NuDate value={item.shipped} format="DD MMM YYYY" /> : "N/A"}
                    </td>
                    <td className="py-2.5 px-2 text-right">
                      <span className="text-[10px] font-bold px-2 py-0.5 rounded-full bg-emerald-50 text-emerald-700 border border-emerald-200/50">
                        {item?.orderReceived ? <NuDate value={item.orderReceived} format="DD MMM YYYY" /> : "N/A"}
                      </span>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={3} className="py-6 text-center text-gray-400">
                    No recently received orders available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default OrderReceived;